import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ConnectionIcon from 'components/icons/ConnectionIcon'
import CandidateDetails from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/CandidateDetails'
import { FooterFlex } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ManyToManyPreview/style'
import {
  AdjustIcon,
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  ContentDiv,
  DetailsNameDiv,
  DetailsTitleDiv,
  InterviwerFlex,
  LeftFlex,
  LinkSpan,
  MainFlex,
  RightFlex,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/OneToOnePreview/style'
import ScheduledSuccessfully from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ScheduledSuccessfully/index'
import moment from 'moment'
import React, { Fragment } from 'react'
import { Convert24hrTo12hr } from 'utils/Convert24hrTo12hr'

const ScheduleDetails = ({
  interviewType,
  interviewInfo,
  isSingleOrBulk,
  selectedCandidate,
  setScheduleDrawer,
  setPrivew,
  scheduleInterview,
  preview,
  isOneDayDrive,
  isLoading,
  candidateInfoData,
  setInterviewType,
  count,
  isBulk,
  selectedRoundType,
  inteviewer,
}) => {
  const handleConfirm = async () => {
    let response = await scheduleInterview(true, interviewInfo)
    if (response) {
      setInterviewType(false)
    }
  }

  const handleBack = () => {
    setScheduleDrawer(true)
    setPrivew(false)
  }
  const getDate = () => {
    return isOneDayDrive ? (
      moment(interviewInfo?.dates[0]).format('DD/MM/YYYY')
    ) : interviewInfo?.dates[0] === interviewInfo?.dates[1] ? (
      moment(interviewInfo?.dates[0]).format('DD/MM/YYYY')
    ) : (
      <Flex>
        <Fragment>
          {moment(interviewInfo?.dates[0]).format('DD/MM/YYYY')}
        </Fragment>
        &nbsp;-&nbsp;
        <Fragment>
          {moment(interviewInfo?.dates[1]).format('DD/MM/YYYY')}
        </Fragment>
      </Flex>
    )
  }
  const getTime = () => {
    return (
      <Flex>
        <Fragment>{Convert24hrTo12hr(interviewInfo?.startTime)}</Fragment>
        &nbsp;-&nbsp;
        <Fragment>
          {moment(
            moment(interviewInfo?.startTime, 'hh:mm:ss').add(
              interviewInfo?.duration,
              'minutes'
            )
          ).format('hh:mm A')}
        </Fragment>
      </Flex>
    )
  }
  const content = () => {
    return (
      <>
        {interviewType == 'FACE_TO_FACE+' && !isSingleOrBulk && (
          <div>
            <MainFlex>
              <AdjustIcon>
                <ConnectionIcon />
              </AdjustIcon>
              <InterviwerFlex column>
                <CollageDetailsFlex spaceBetween centerVertically>
                  <Flex alignCenter>
                    <AntdAvatar
                      size={36}
                      IconName={candidateInfoData?.student?.firstName?.charAt(
                        0
                      )}
                    />

                    <CollageNameFlex>
                      <CollegeNameDiv>
                        {candidateInfoData?.student?.firstName}{' '}
                        {candidateInfoData?.student?.lastName}
                      </CollegeNameDiv>
                      {}
                    </CollageNameFlex>
                  </Flex>
                </CollageDetailsFlex>
                {interviewInfo?.linkAndPanel[0]?.panel?.map((data, index) => {
                  return (
                    <CollageDetailsFlex
                      spaceBetween
                      centerVertically
                      key={index + data?.firstName}
                    >
                      <Flex alignCenter>
                        <AntdAvatar
                          size={36}
                          IconName={data?.firstName?.charAt(0)}
                        />

                        <CollageNameFlex>
                          <CollegeNameDiv>
                            {data?.firstName} {data?.lastName}
                          </CollegeNameDiv>
                          <CollegeCity>{data?.email}</CollegeCity>
                        </CollageNameFlex>
                      </Flex>
                    </CollageDetailsFlex>
                  )
                })}
              </InterviwerFlex>
            </MainFlex>
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Date</DetailsNameDiv>
                <ContentDiv>{getDate()}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Time</DetailsNameDiv>
                <ContentDiv>{getTime()}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewInfo?.mode === 'OFFLINE'
                    ? interviewInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>
          </div>
        )}
        {(interviewType == 'ASSESMENT' ||
          interviewType == 'EXTERNAL_ASSESMENT') && (
          <>
            {isSingleOrBulk && (
              <CandidateDetails
                selectedCandidate={selectedCandidate}
                count={isBulk ? count : selectedCandidate?.length}
                isBulk={isBulk}
              />
            )}
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Date</DetailsNameDiv>
                <ContentDiv>{getDate()}</ContentDiv>
              </LeftFlex>
              {interviewInfo?.startTime && (
                <LeftFlex>
                  <DetailsNameDiv>Time</DetailsNameDiv>
                  <ContentDiv>{getTime()}</ContentDiv>
                </LeftFlex>
              )}
              <LeftFlex>
                <DetailsNameDiv>Duration</DetailsNameDiv>
                <ContentDiv>{interviewInfo?.duration} Mins</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Evaluation type</DetailsNameDiv>{' '}
                <ContentDiv>
                  {interviewInfo?.interviewType?.toLowerCase()}
                </ContentDiv>
              </LeftFlex>

              <LeftFlex>
                <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewInfo?.mode === 'OFFLINE'
                    ? interviewInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>

              {interviewInfo?.location && (
                <LeftFlex>
                  <DetailsNameDiv>Location</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.location?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel[0]?.panel && (
                <LeftFlex>
                  <DetailsNameDiv>Interviewer</DetailsNameDiv>
                  <ContentDiv>{inteviewer?.length}</ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel[0]?.link && (
                <LeftFlex>
                  <DetailsNameDiv>Link</DetailsNameDiv>
                  <ContentDiv noCap>
                    <LinkSpan
                      href={interviewInfo?.linkAndPanel[0]?.link}
                      target="_blank"
                    >
                      {interviewInfo?.linkAndPanel[0]?.link || '-'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>
          </>
        )}

        {(interviewType == 'GROUP' || interviewType == 'FACE_TO_FACE') && (
          <div>
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Round Name</DetailsNameDiv>
                <ContentDiv>{interviewInfo?.interviewRound}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Round Type</DetailsNameDiv>{' '}
                <ContentDiv>
                  {interviewInfo?.interviewType === 'FACE_TO_FACE'
                    ? 'Face to Face'
                    : interviewInfo?.interviewType === 'GROUP'
                    ? 'Group Discussion'
                    : interviewInfo?.interviewType?.toLowerCase()}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Date</DetailsNameDiv>
                <ContentDiv>{getDate()}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Time</DetailsNameDiv>
                <ContentDiv>
                  {Convert24hrTo12hr(interviewInfo?.startTime) +
                    '-' +
                    Convert24hrTo12hr(interviewInfo?.endTime)}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Duration</DetailsNameDiv>
                <ContentDiv>{interviewInfo?.duration} Min(Each)</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewInfo?.mode === 'OFFLINE'
                    ? interviewInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>

              {interviewInfo?.location && (
                <LeftFlex>
                  <DetailsNameDiv>Location</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.location?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel[0]?.panel && (
                <LeftFlex>
                  <DetailsNameDiv>Interviewer</DetailsNameDiv>
                  <ContentDiv>{inteviewer?.length}</ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel && (
                <LeftFlex>
                  <DetailsNameDiv>Panel</DetailsNameDiv>
                  <ContentDiv>
                    <LinkSpan>
                      {interviewInfo?.linkAndPanel?.length || '0'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>{' '}
          </div>
        )}
        {!interviewType && (
          <ScheduledSuccessfully
            interviewType={interviewType}
            setPrivew={setPrivew}
            isSingleOrBulk={isSingleOrBulk}
            interviewInfo={interviewInfo}
            selectedRoundType={selectedRoundType}
          />
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <Fragment>
        {interviewType && (
          <FooterFlex flexEnd>
            <Button.Secondary
              width="88px"
              height="38px"
              text="Back"
              onClick={handleBack}
            />
            <Button.Primary
              width="95px"
              height="38px"
              text="Proceed"
              onClick={handleConfirm}
              loading={isLoading}
            />
          </FooterFlex>
        )}
      </Fragment>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Preview'}
      placement="right"
      visible={preview}
      content={content()}
      footer={footer()}
      onClose={() => {
        setPrivew(false)
        setScheduleDrawer(true)
      }}
      closable
    />
  )
}

export default ScheduleDetails
